export const environment = {
  BASE_AUTH_URL: "https://stg.employee.talero.eu/",
  BASE_URL: "https://stg.employee.talero.eu/api/",
  AUTH_API_BASE_URL: "https://stg.employee.talero.eu/api",
  production: false,
  imagePath: "assets/images",
};
